// extracted by mini-css-extract-plugin
export default {"chip":"styles_chip__fahdz","success":"styles_success__1HRbb","error":"styles_error__bM2bb"};